import CtmInsightsCRUDActions from '../actions/CtmInsightsCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { CtmInsightsState } from '../interfaces/ctmInsights';
import {
  CtmAnalyticsModel,
  CtmAnalyticsQuery,
  queryToString,
} from '../model/CtmAnalyticsModel';

const initialState: CtmInsightsState = {
  busy: false,
  entities: {},
};

const retrieveForQuery = (
  state: CtmInsightsState,
  action: {
    results: {
      data: CtmAnalyticsModel[];
      next: string | null;
      prev: string | null;
    };
    query: CtmAnalyticsQuery;
  },
) => {
  const {
    results: { data, next, prev },
    query,
  } = action;
  const queryKey = queryToString(query);
  return {
    ...state,
    busy: false,
    entities: { ...state.entities, [queryKey]: { data, next, prev } },
  };
};

export function ctmInsights(state = initialState, action: any) {
  switch (action.type) {
    case CtmInsightsCRUDActions.busyAction:
      return setBusy(state);
    case CtmInsightsCRUDActions.unbusyAction:
      return setUnBusy(state);
    case CtmInsightsCRUDActions.retrieveForQueryAction:
      return retrieveForQuery(state, action);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
